import { useQuery, useQueryClient } from '@tanstack/react-query';
import { ResourceQueryService } from '@lib/common-sdk';
import { ProjectBranchViewModel } from '@lib/api-interface';
import axios from 'axios';

export const useProjectBranchView = (projectBranchId: string | undefined) => {
  const queryKey = ['projectBranchViews', projectBranchId];
  const queryClient = useQueryClient();

  const query = useQuery({
    queryKey: queryKey,
    queryFn: (context) => {
      return ResourceQueryService.findOneByField<ProjectBranchViewModel>('/api/resource/projectBranchViews', 'projectBranchId', projectBranchId);
    },
    staleTime: 3000,
  });

  const invalidateQuery = async () => {
    await queryClient.invalidateQueries({ queryKey: queryKey });
  };

  return [query, invalidateQuery] as const;
};

export const getProjectBranchViewForClient = async () => {
  return await axios.get(`${import.meta.env.VITE_API_URL}/api/resource/project-branch-view`).then((res) => res.data);
};
